import type { AnyApiReferenceConfiguration } from "@scalar/api-reference-react";
import { API_REFERENCES, type ApiReference } from "@/config/api-references";

const baseConfiguration = {
  layout: "modern",
  theme: "default",
  withDefaultFonts: false,
  showOperationId: true,
  showDeveloperTools: "never",
  // Keep the public spec in the visitor's browser rather than uploading it to
  // Scalar's optional hosted agent service.
  agent: {
    disabled: true,
  },
  // Scalar enables MCP editor promotions automatically on localhost unless
  // explicitly disabled. The reference remains a focused Beancount surface.
  mcp: {
    disabled: true,
  },
  customCss: `
    .darklight-reference a[href="https://www.scalar.com"] {
      display: none;
    }
  `,
} satisfies AnyApiReferenceConfiguration;

export function apiReferenceConfiguration(
  isDark: boolean,
  locale: string,
  productionServer: string,
  api: ApiReference = "beancount",
) {
  const sharedConfiguration = {
    ...baseConfiguration,
    url: API_REFERENCES[api].specUrl,
    darkMode: isDark,
    localization: {
      locale,
      direction: "auto",
    },
  } satisfies AnyApiReferenceConfiguration;

  // Server and authentication overrides belong only to the ledger API. Prices
  // uses the servers and security schemes declared by its own OpenAPI document.
  if (api === "prices") return sharedConfiguration;

  return {
    ...sharedConfiguration,
    authentication: { preferredSecurityScheme: "bearerAuth" },
    servers: [
      { url: "https://api.v3.beancount.io", description: productionServer },
    ],
  } satisfies AnyApiReferenceConfiguration;
}
